import { useTranslations } from "next-intl"
import { dashboardRoutesPaths } from "@/routes/dashboard"
import { type MenuItem } from "../types/menuItem"

export function useMenuItemsCollection() {
    const t = useTranslations("useMenuItemsCollection")

    return {
        account: (accountNumber: string, propertyId: string) => ({
            label: t("account"),
            href: dashboardRoutesPaths.property.resolve({
                pathParams: {
                    accountNumber,
                    propertyId,
                },
            }),
            key: "account",
        }),
        payments: (accountNumber: string, propertyId: string) => ({
            label: t("payments"),
            href: dashboardRoutesPaths.billsAndPayments.resolve({
                pathParams: {
                    accountNumber,
                    propertyId,
                },
            }),
            key: "payments",
        }),
        consumption: (accountNumber: string, propertyId: string) => ({
            label: t("consumption"),
            href: dashboardRoutesPaths.consumption.resolve({
                pathParams: {
                    accountNumber,
                    propertyId,
                },
            }),
            key: "consumption",
        }),
        contracts: (accountNumber: string, propertyId: string) => ({
            label: t("contrats"),
            href: dashboardRoutesPaths.agreements.resolve({
                pathParams: {
                    accountNumber,
                    propertyId,
                },
            }),
            key: "contracts",
        }),
        personalDetails: {
            label: t("accountDetails"),
            href: dashboardRoutesPaths.personalDetails.resolve(),
            key: "personalDetails",
        },
        pot: (accountNumber: string) => ({
            label: t("pot"),
            href: dashboardRoutesPaths.pot.resolve({ pathParams: { accountNumber } }),
            key: "pot",
        }),
        referral: (accountNumber: string) => ({
            label: t("referral"),
            href: dashboardRoutesPaths.referral.resolve({ pathParams: { accountNumber } }),
            key: "referral",
        }),
        accounts: {
            label: t("switchAccount"),
            href: dashboardRoutesPaths.accounts.resolve(),
            key: "switchAccount",
        },
    } as const satisfies Record<string, MenuItem | ((...args: string[]) => MenuItem)>
}

useMenuItemsCollection.messages = ["useMenuItemsCollection"] as const
